import { Injectable, signal, WritableSignal } from '@angular/core';
import { Router } from '@angular/router';
import { map, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { PermissionEnum, Permissions, RequestMethodEnum, RequestOptions, Response } from '@models';
import { GenericService } from './generic.service';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  set permissions(permissions: Permissions) {
    this._permissions.set(permissions);
    void this.router.navigateByUrl(this.router.url);
  }
  get permissions(): WritableSignal<Permissions | undefined> {
    return this._permissions;
  }
  private _permissions: WritableSignal<Permissions | undefined> = signal(undefined);

  constructor(
    private router: Router,
    private genericService: GenericService,
  ) {}

  hasPermission(requiredPermissions: PermissionEnum[], resource = 'monitor'): boolean {
    const permissions = this._permissions();
    const appPermissions = permissions?.[resource] ?? [];

    return (
      requiredPermissions.length > 0 &&
      appPermissions.length > 0 &&
      requiredPermissions.every(permission => appPermissions.includes(permission))
    );
  }

  permissions$(): Observable<Permissions> {
    const options: RequestOptions<undefined, Response<Permissions>> = {
      fullResponse: true,
      method: RequestMethodEnum.GET,
      path: `api/v1/users/permissions`,
    };
    return this.genericService.request(options).pipe(
      map(response => response.data),
      tap(permissions => (this.permissions = permissions)),
    );
  }
}
